module.exports = __webpack_public_path__ + "img/p69-logo.c243b65d.svg";